import { Component, OnInit, Input } from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
//Ventana Modal
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
//Formularios
import { NgForm } from '@angular/forms';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//Alertas
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
//Tabs
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';
import { ViewChild, ElementRef } from '@angular/core';
//Acordeon
import {AccordionModule} from "ng2-accordion";
//Servicios
import { ConfigService } from '../../../servicios/config/config.service';
import { ValidService } from '../../../servicios/valid.service';
import { KeyService } from '../../../servicios/key.service';
import { PerfilesService } from '../../../servicios/perfiles/perfiles.service';
import { UsuariosService } from '../../../servicios/usuarios/usuarios.service';
import { EventosJqueryService } from '../../../servicios/eventos-jquery/eventos-jquery.service';
//Arbol
import { TreeviewItem, TreeviewConfig, TreeItem } from 'ngx-treeview';


//Variable global para usa jQuery
declare var $:any;

@Component({
  selector: 'app-perfil-acciones',
  templateUrl: './perfil-acciones.component.html',
  styleUrls: ['./perfil-acciones.component.css']
})
export class PerfilAccionesComponent implements OnInit {


  clienteSucursal           : any = localStorage.getItem('clienteSucursal'); // almacena el el perfil del usuario para vaklidar si es de tipo C es cliente desde usarios

  /* ------------------------------------- */
  //Bloque para controlar el arbol de permisos
  items_configuracion       : TreeviewItem[];
  items_administracion      : TreeviewItem[];
  items_informes            : TreeviewItem[];
  items_gestionincidencias  : TreeviewItem[];
  items_alertas             : TreeviewItem[];
  items_servicios           : TreeviewItem[];
  items_dashboard           : TreeviewItem[];
  values                    : number[];
  config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 800
  });
  /* ------------------------------------- */

  arbol_opciones = new Array(); //Arreglo de opciones
  permisos_modulos : any;
  permisos_modulos_1 : any;
  permisos_modulos_2 : any;

  getUsuarioid  : any = localStorage.getItem('usuarioid');
  usuarioid     = this.getUsuarioid;

  idperfil              : any;
  idusuario             : any;

  label_titulo_perfil   = '';
  estadoDisabled        : boolean; //Estado en que se encuentra un campo (enabled, disabled)
  formAcciones          : FormGroup;  //Formulario
  listusuarios          : any;
  listperfiles          : any;

  mostraropcionModal : boolean = true;

  //Obtener parametros del storage
  paramusuarioid  : any = localStorage.getItem('paramusuarioid');
  paramperfilid   : any = localStorage.getItem('paramperfilid');
  
  //Objeto que contiene las variables para los campos del formulario
  perfiles = {
    idusuario : '', usuarioid : '', nombreusuario : '', idperfil : '', perfilid : '',  nombreperfil : ''
  }

  //Declaraciones para los tabs
  disableSwitching: boolean;
  @ViewChild('tabset', {read: ElementRef}) tabsetEl: ElementRef;
  @ViewChild('tabset')  tabset  : TabsetComponent;
  @ViewChild('first')   first   : TabDirective;
  @ViewChild('second')  second  : TabDirective;
  @ViewChild('third')   third   : TabDirective;
  @ViewChild('fourth')  fourth  : TabDirective;
  @ViewChild('fifth')   fifth   : TabDirective;
  @ViewChild('six')       six   : TabDirective;


  //Constructor
  constructor(
    private _config       : ConfigService,
    private _valid        : ValidService,
    private _key          : KeyService,
    private route         : ActivatedRoute,
    private router        : Router,
    private http          : Http,
    private modalService  : BsModalService,
    private toastr        : ToastrService,
    private _perfiles     : PerfilesService,
    private _usuarios     : UsuariosService,
    private _evtjq        : EventosJqueryService
  ) {}


  ngOnInit() 
  {
    //Escucha los eventos al presionar la tecla Enter
    this._evtjq.eventoTeclaEnter();
    
    //Si llega parametro enviado desde el componente usuarios
    if (this.paramusuarioid) {
      this.idusuario = this.paramusuarioid;
      this.label_titulo_perfil  = 'Asignar Permisos a Usuario';
      this.estadoDisabled = false;
    }
    
    //Si llega parametro enviado desde el componente perfil
    if (this.paramperfilid) {
      this.idperfil = this.paramperfilid;
      this.label_titulo_perfil  = 'Asignar Permisos a Perfil';
      this.estadoDisabled = true;
    }

    this.getPermisos(this.idusuario, this.idperfil);
    this.getPerfiles();
    this.getUsuarios();
    this.createForm();
  }

  


  /** 
   * Permite la confirmación de los Tabs
   * JMM-2018-08-02
  */
  confirmTabSwitch($event) 
  {
    if (this.disableSwitching) {
      const confirm = window.confirm('Discard changes and switch tab?');
      if (confirm) {
        this.disableSwitching = false;
        const liArr = Array.from(this.tabsetEl.nativeElement.querySelectorAll('ul li'));
        let tabIndex;
        liArr.forEach((li, i) => {
        });
        setTimeout(() => {
          this.tabset.tabs[tabIndex].active = true;
        });
      }
    }
  }// .confirmTabSwitch($event) 


  /**
   * Función para optener el listado de perfiles
   * JMM-2018-12-04
   */
  getPerfiles()
  {
    this._perfiles.getPerfiles().subscribe((resp)=>{
      if (resp.data) 
      {
        this.listperfiles = resp.data;
        for (let i in resp.data) 
        {
          if (this.idperfil == resp.data[i].id && resp.data[i].estado == 'A') 
          {
            this.perfiles.idperfil      = resp.data[i].id;
            this.perfiles.perfilid      = resp.data[i].perfilid;
            this.perfiles.nombreperfil  = resp.data[i].nombre;
          }
        }
      }
    });
  }// .getPerfiles()


  /**
   * Función para optener el listado de usuarios
   * JMM-2018-12-04
   */
  getUsuarios()
  {
    this._usuarios.getUsuarios().subscribe((resp)=>{
      if (resp.data) 
      {
        this.listusuarios = resp.data;
        for (let i in resp.data)
        {
          if (this.idusuario == resp.data[i].usuarioid && resp.data[i].estado == 'A')
          {
            this.perfiles.idusuario     = resp.data[i].id;
            this.perfiles.usuarioid     = resp.data[i].usuarioid;
            this.perfiles.nombreusuario = resp.data[i].nombre;
          }
          else if (this.paramusuarioid == resp.data[i].usuarioid && resp.data[i].estado == 'A')
          {
            this.perfiles.idusuario     = resp.data[i].id;
            this.perfiles.usuarioid     = resp.data[i].usuarioid;
            this.perfiles.nombreusuario = resp.data[i].nombre;
          }
        }
      }
    });
  }// .getUsuarios()


  /**
   * Envia la peticion a un servicio para actualizar o guardar los datos
   * JMM-2015-12-04
   */
  submit()
  {
    let itemsPermisos = new Array();
    let datospermisos : any;

    //PERMISOS PARA CONFIGURACION
    //ABUELO
    if (this.items_configuracion[0].checked == true) {
      itemsPermisos.push(
        datospermisos = {
          usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
          perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
          opcion    : this.items_configuracion[0].value
        }
      );
    }
    //PADRE
    for (let i in this.items_configuracion[0].internalChildren) {
      if (this.items_configuracion[0].internalChildren[i].internalChecked == true) {
        itemsPermisos.push(
          datospermisos = {
            usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
            perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
            opcion    : this.items_configuracion[0].internalChildren[i].value
          }
        );
      }
      //HIJO
      for (let j in this.items_configuracion[0].internalChildren[i].internalChildren) {
        if (this.items_configuracion[0].internalChildren[i].internalChildren[j].checked == true) {
          itemsPermisos.push(
            datospermisos = {
              usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
              perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
              opcion    : this.items_configuracion[0].internalChildren[i].internalChildren[j].value
            }
          );
        }
        //NIETO
        for (let k in this.items_configuracion[0].internalChildren[i].internalChildren[j].internalChildren) {
          if (this.items_configuracion[0].internalChildren[i].internalChildren[j].internalChildren[k].checked == true) {
            itemsPermisos.push(
              datospermisos = {
                usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
                perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
                opcion    : this.items_configuracion[0].internalChildren[i].internalChildren[j].internalChildren[k].value
              }
            );
          }
        }
      }
    }

    //PERMISOS PARA ADMINISTRACION
    //PADRE
    if (this.items_administracion[0].checked == true) {
      itemsPermisos.push(
        datospermisos = {
          usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
          perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
          opcion    : this.items_administracion[0].value
        }
      );
    }
    //PADRE
    for (let i in this.items_administracion[0].internalChildren) {
      if (this.items_administracion[0].internalChildren[i].internalChecked == true) {
        itemsPermisos.push(
          datospermisos = {
            usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
            perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
            opcion    : this.items_administracion[0].internalChildren[i].value
          }
        );
      }
      //HIJO
      for (let j in this.items_administracion[0].internalChildren[i].internalChildren) {
        if (this.items_administracion[0].internalChildren[i].internalChildren[j].checked == true) {
          itemsPermisos.push(
            datospermisos = {
              usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
              perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
              opcion    : this.items_administracion[0].internalChildren[i].internalChildren[j].value
            }
          );
        }
        //NIETO
        for (let k in this.items_administracion[0].internalChildren[i].internalChildren[j].internalChildren) {
          if (this.items_administracion[0].internalChildren[i].internalChildren[j].internalChildren[k].checked == true) {
            itemsPermisos.push(
              datospermisos = {
                usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
                perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
                opcion    : this.items_administracion[0].internalChildren[i].internalChildren[j].internalChildren[k].value
              }
            );
          }
        }
      }
    }

    //PERMISOS PARA INFORMES
    //ABUELO
    if (this.items_informes[0].checked == true) {
      itemsPermisos.push(
        datospermisos = {
          usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
          perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
          opcion    : this.items_informes[0].value
        }
      );
    }
    //PADRE
    for (let i in this.items_informes[0].internalChildren) {
      if (this.items_informes[0].internalChildren[i].internalChecked == true) {
        itemsPermisos.push(
          datospermisos = {
            usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
            perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
            opcion    : this.items_informes[0].internalChildren[i].value
          }
        );
      }
      //HIJO
      for (let j in this.items_informes[0].internalChildren[i].internalChildren) {
        if (this.items_informes[0].internalChildren[i].internalChildren[j].checked == true) {
          itemsPermisos.push(
            datospermisos = {
              usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
              perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
              opcion    : this.items_informes[0].internalChildren[i].internalChildren[j].value
            }
          );
        }
        //NIETO
        for (let k in this.items_informes[0].internalChildren[i].internalChildren[j].internalChildren) {
          if (this.items_informes[0].internalChildren[i].internalChildren[j].internalChildren[k].checked == true) {
            itemsPermisos.push(
              datospermisos = {
                usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
                perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
                opcion    : this.items_informes[0].internalChildren[i].internalChildren[j].internalChildren[k].value
              }
            );
          }
        }
      }
    }

    //PERMISOS PARA GESTION DE INCIDENCIAS
    //ABUELO
    if (this.items_gestionincidencias[0].checked == true) {
      itemsPermisos.push(
        datospermisos = {
          usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
          perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
          opcion    : this.items_gestionincidencias[0].value
        }
      );
    }
    //PADRE
    for (let i in this.items_gestionincidencias[0].internalChildren) {
      if (this.items_gestionincidencias[0].internalChildren[i].internalChecked == true) {
        itemsPermisos.push(
          datospermisos = {
            usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
            perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
            opcion    : this.items_gestionincidencias[0].internalChildren[i].value
          }
        );
      }
      //HIJO
      for (let j in this.items_gestionincidencias[0].internalChildren[i].internalChildren) {
        if (this.items_gestionincidencias[0].internalChildren[i].internalChildren[j].checked == true) {
          itemsPermisos.push(
            datospermisos = {
              usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
              perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
              opcion    : this.items_gestionincidencias[0].internalChildren[i].internalChildren[j].value
            }
          );
        }
        //NIETO
        for (let k in this.items_gestionincidencias[0].internalChildren[i].internalChildren[j].internalChildren) {
          if (this.items_gestionincidencias[0].internalChildren[i].internalChildren[j].internalChildren[k].checked == true) {
            itemsPermisos.push(
              datospermisos = {
                usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
                perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
                opcion    : this.items_gestionincidencias[0].internalChildren[i].internalChildren[j].internalChildren[k].value
              }
            );
          }
        }
      }
    }

    //PERMISOS PARA ALERTAS
    //ABUELO
    if (this.items_alertas[0].checked == true) {
      itemsPermisos.push(
        datospermisos = {
          usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
          perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
          opcion    : this.items_alertas[0].value
        }
      );
    }
    //PADRE
    for (let i in this.items_alertas[0].internalChildren) {
      if (this.items_alertas[0].internalChildren[i].internalChecked == true) {
        itemsPermisos.push(
          datospermisos = {
            usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
            perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
            opcion    : this.items_alertas[0].internalChildren[i].value
          }
        );
      }
      //HIJO
      for (let j in this.items_alertas[0].internalChildren[i].internalChildren) {
        if (this.items_alertas[0].internalChildren[i].internalChildren[j].checked == true) {
          itemsPermisos.push(
            datospermisos = {
              usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
              perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
              opcion    : this.items_alertas[0].internalChildren[i].internalChildren[j].value
            }
          );
        }
        //NIETO
        for (let k in this.items_alertas[0].internalChildren[i].internalChildren[j].internalChildren) {
          if (this.items_alertas[0].internalChildren[i].internalChildren[j].internalChildren[k].checked == true) {
            itemsPermisos.push(
              datospermisos = {
                usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
                perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
                opcion    : this.items_alertas[0].internalChildren[i].internalChildren[j].internalChildren[k].value
              }
            );
          }
        }
      }
    }

    //PERMISOS PARA SERVICOS
    //ABUELO
    if (this.items_servicios[0].checked == true) {
      itemsPermisos.push(
        datospermisos = {
          usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
          perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
          opcion    : this.items_servicios[0].value
        }
      );
    }
    //PADRE
    for (let i in this.items_servicios[0].internalChildren) {
      if (this.items_servicios[0].internalChildren[i].internalChecked == true) {
        itemsPermisos.push(
          datospermisos = {
            usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
            perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
            opcion    : this.items_servicios[0].internalChildren[i].value
          }
        );
      }
      //HIJO
      for (let j in this.items_servicios[0].internalChildren[i].internalChildren) {
        if (this.items_servicios[0].internalChildren[i].internalChildren[j].checked == true) {
          itemsPermisos.push(
            datospermisos = {
              usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
              perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
              opcion    : this.items_servicios[0].internalChildren[i].internalChildren[j].value
            }
          );
        }
        //NIETO
        for (let k in this.items_servicios[0].internalChildren[i].internalChildren[j].internalChildren) {
          if (this.items_servicios[0].internalChildren[i].internalChildren[j].internalChildren[k].checked == true) {
            itemsPermisos.push(
              datospermisos = {
                usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
                perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
                opcion    : this.items_servicios[0].internalChildren[i].internalChildren[j].internalChildren[k].value
              }
            );
          }
        }
      }
    }

      //PERMISOS PARA DASHBOARD
    //ABUELO
    if (this.items_dashboard[0].checked == true) {
      itemsPermisos.push(
        datospermisos = {
          usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
          perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
          opcion    : this.items_dashboard[0].value
        }
      );
    }
    //PADRE
    for (let i in this.items_dashboard[0].internalChildren) {
      if (this.items_dashboard[0].internalChildren[i].internalChecked == true) {
        itemsPermisos.push(
          datospermisos = {
            usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
            perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
            opcion    : this.items_dashboard[0].internalChildren[i].value
          }
        );
      }
      //HIJO
      for (let j in this.items_dashboard[0].internalChildren[i].internalChildren) {
        if (this.items_dashboard[0].internalChildren[i].internalChildren[j].checked == true) {
          itemsPermisos.push(
            datospermisos = {
              usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
              perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
              opcion    : this.items_dashboard[0].internalChildren[i].internalChildren[j].value
            }
          );
        }
        //NIETO
        for (let k in this.items_dashboard[0].internalChildren[i].internalChildren[j].internalChildren) {
          if (this.items_dashboard[0].internalChildren[i].internalChildren[j].internalChildren[k].checked == true) {
            itemsPermisos.push(
              datospermisos = {
                usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
                perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
                opcion    : this.items_dashboard[0].internalChildren[i].internalChildren[j].internalChildren[k].value
              }
            );
          }
        }
      }
    }


    let listpermisos = { 
      usuarioid : this.formAcciones.value.usuarioid ? this.formAcciones.value.usuarioid : null,
      perfilid  : this.formAcciones.value.idperfil ? this.formAcciones.value.idperfil : null,
      permisos  : itemsPermisos
    }
    
    this.enviarCrear(listpermisos);
  }// .submit()


  /**
   * Permite enviar la petición a un servicio para crear el registro
   * JMM-2018-12-06
   */
  enviarCrear(listpermisos)
  {
    //Se envian los datos para ser guardados
    this._perfiles.setPermisos(listpermisos).subscribe((resp) => {
      console.log('setPermisos',resp.data);
      
      if (resp.error) {
        this.toastr.error('No se pudo crear el registro', 'Error', { timeOut: 3000 });
      } else {
        this.toastr.success(resp.message, '', { timeOut: 3000 });
        this.ngOnInit();
      }
    });
  }// .enviarCrear()


  /**
   * Permite obtener el listado de permisos
   * JMM-2018-12-07
   */
  getPermisos(idusuario, idperfil)
  {
    this._perfiles.getPermisos(idusuario, idperfil).subscribe((resp) => {
      
      if (resp.data) 
      {
        let arreglopermisos = new Array(); 

        for (let i in resp.data) {
          arreglopermisos.push(resp.data[i].opcion);
        }

        this.items_configuracion      = this._perfiles.getOptions_configuracion(arreglopermisos);
        this.items_administracion     = this._perfiles.getOptions_administracion(arreglopermisos);
        this.items_informes           = this._perfiles.getOptions_informes(arreglopermisos);
        this.items_gestionincidencias = this._perfiles.getOptions_gestionincidencias(arreglopermisos);
        this.items_alertas            = this._perfiles.getOptions_especiales(arreglopermisos);
        this.items_servicios          = this._perfiles.getOptions_Servicios(arreglopermisos);
        this.items_dashboard          = this._perfiles.getOptions_dashboard(arreglopermisos);
      }
    });
  }// .getPermisos(idusuario, idperfil)


  /**
   * Permite cerrar un modal
   * JMM-2019-01-02
   */
  cerrarmodal() 
  {
    //Se remueven los parametros del estorage
    localStorage.removeItem('paramusuarioid');
    localStorage.removeItem('paramperfilid');
    localStorage.removeItem('clienteSucursal');  

    //Se remueve el modal 
    $('.modal, .modal-backdrop').fadeOut();
    $('.modal').remove();
    
    //Se habilita el scroll del navegador
    document.getElementsByTagName("html")[0].style.overflow="auto";
  }// .cerrarmodal()


  /**
   * Permite validar el formulario
   * JMM-2018-08-02
   */
  createForm()
  {    
    this.formAcciones = new FormGroup({
      'idusuario'     : new FormControl(this.perfiles.idusuario, [Validators.required]),
      'usuarioid'     : new FormControl(this.perfiles.usuarioid),
      'nombreusuario' : new FormControl(this.perfiles.nombreusuario),
      'idperfil'      : new FormControl(this.perfiles.idperfil, [Validators.required]),
      'perfilid'      : new FormControl(this.perfiles.perfilid),
      'nombreperfil'  : new FormControl(this.perfiles.nombreperfil) 
    });
  }// .createForm()

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/perfiles/perfil-acciones/perfil-acciones.component.ts